wbApp.controller('FormResponsePreviewDetailCtrl', ['$scope', '$q', 'formSvc', 'formResponseSvc', 'userSvc', 'studentSvc',
function ($scope, $q, formSvc, formResponseSvc, userSvc, studentSvc) {

    // $scope.formId
  
    $scope.adminEdit = !$scope.formResponseId;
    $scope.isSaving = false;

    $scope.shouldEnableSaveButton = function () {
        return !!$scope.formResponse.isValid && !$scope.isSaving && !!$scope.enableSave;
    }

    $scope.formResponse = {
        id: $scope.formResponseId
    };

    function saveResponse(response) {

        let responseDto = angular.copy(response);
        responseDto.user = null;
        responseDto.student = null;
        responseDto.showFullEditableUserDetail = null;

        formResponseSvc.insert(responseDto).$promise.then(function (success) {
                if (!!$scope.formSaved) {
                    $scope.formSaved(success);
                }            
                $scope.isSaving = false;
                $scope.$hide();
            },
            function (error) {
                $scope.isSaving = false;
            })
    }

    $scope.onSaveClick = function () {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (($scope.formResponse.showFullEditableUserDetail || $scope.formResponse.showFullEditableStudentDetail) &&
            !$scope.formResponse.isNotRegisteredUser) {

            let promises = [];

            if (!!$scope.formResponse.user && $scope.formResponse.showFullEditableUserDetail) {
                promises.push(userSvc.update($scope.formResponse.user, null, null, true));
            }

            if (!!$scope.formResponse.student && $scope.formResponse.showFullEditableStudentDetail) {
                promises.push(studentSvc.update($scope.formResponse.student, null, null, null, true));
            }

            $q.all(promises).then(function() {
                saveResponse($scope.formResponse);
            }, function (error) {
                $scope.isSaving = false;
                $scope.respondedSuccesfully = false;
                $scope.errorDetail = error;
            });
        }
        else{
            saveResponse($scope.formResponse);
        }        
    }

}]);
